import React from 'react';

import LogoImg from '@assets/svg/logo-gray.svg';
import WarningImg from '@assets/svg/warning-sign.svg';

import {
  Overlay,
  Container,
  Header,
  Logo,
  Divider,
  Alert,
  Title,
  Description,
  Row,
} from './UserBlockedAlert.styles';

const UserBlockedAlert = () => {
  return (
    <Overlay>
      <Container>
        <Header>
          <Row>
            <Logo src={LogoImg} alt="Logo" />
          </Row>

          <Divider />

          <Alert src={WarningImg} alt="Warning Sign" />

          <Title>Sorry, your account has been blocked.</Title>

          <Description>
            Please reach out to your company`&apos;`s admin.
          </Description>
        </Header>
      </Container>
    </Overlay>
  );
};

export { UserBlockedAlert };
